import { PropType, defineComponent } from 'vue';
import styles from './index.module.scss';
import classNames from 'classnames';
import { StepsID } from '..';
import SVG from '@dts/shared/src/assets/svg';

const StepMask = defineComponent({
  setup: (props) => {
    return () => (
      <div class={styles.StepMask}>
        <div class={styles.arrowStep} id={StepsID.exploreMore} />
        <div class={classNames(styles.arrow, styles.svgAct)}>
          <SVG.TourStepsArrow />
        </div>
      </div>
    );
  },
});
export default StepMask;
